import React, { useState } from "react";
import { Modal, ModalBody, ModalFooter, Form, FormGroup, Input, Button } from "reactstrap";
import axios from "axios";
import { toast } from "react-toastify";

const EnquiryModal = ({ isOpen, toggle }) => {
    const [formData, setFormData] = useState({
        name: "",
        company_name: "",
        phone_number: "",
        email_id: "",
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async () => {
        try {
            await axios.post(`${process.env.REACT_APP_API_URL}/enquiry`, formData);
            toast.success("Enquiry submitted successfully!");
            toggle(); // Close modal after success
            setFormData({ name: "", company_name: "", phone_number: "", email_id: "" });
        } catch (error) {
            toast.error("Failed to submit enquiry. Please try again.");
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} centered>
            <div
                style={{
                    backgroundColor: "rgb(143, 175, 238)",
                    padding: "15px",
                    textAlign: "center",
                }}
            >
                <h4 style={{ color: "rgb(241, 90, 41)", fontWeight: "bold", margin: 0 }}>
                    Enquiry Details
                </h4>
            </div>
            <ModalBody>
                <Form>
                    <FormGroup>
                        <Input type="text" name="name" placeholder="Enter your name" className="rounded-pill p-2" required onChange={handleChange} value={formData.name} />
                    </FormGroup>
                    <FormGroup>
                        <Input type="text" name="company_name" placeholder="Enter your company name" className="rounded-pill p-2" required onChange={handleChange} value={formData.company_name} />
                    </FormGroup>
                    <FormGroup>
                        <Input type="tel" name="phone_number" placeholder="Enter your phone number" className="rounded-pill p-2" required onChange={handleChange} value={formData.phone_number} />
                    </FormGroup>
                    <FormGroup>
                        <Input type="email" name="email_id" placeholder="Enter your email" className="rounded-pill p-2" required onChange={handleChange} value={formData.email_id} />
                    </FormGroup>
                </Form>
            </ModalBody>
            <ModalFooter className="d-flex justify-content-center">
                <Button color="primary" onClick={handleSubmit}>Submit</Button>
                <Button color="secondary" onClick={toggle}>Cancel</Button>
            </ModalFooter>
        </Modal>
    );
};

export default EnquiryModal;
